import { Filter } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

interface CoachOption {
  id: string;
  name: string;
}

interface PlayerOption {
  id: string;
  name: string;
}

interface AttendanceFiltersProps {
  fromDate: string;
  toDate: string;
  onFromDateChange: (value: string) => void;
  onToDateChange: (value: string) => void;
  coachFilter: string;
  playerFilter: string;
  typeFilter: string;
  onCoachFilterChange: (value: string) => void;
  onPlayerFilterChange: (value: string) => void;
  onTypeFilterChange: (value: string) => void;
  coaches: CoachOption[] | null | undefined;
  players: PlayerOption[] | null | undefined;
  showFilters: boolean;
  onToggleFilters: () => void;
}

export function AttendanceFilters({
  fromDate,
  toDate,
  onFromDateChange,
  onToDateChange,
  coachFilter,
  playerFilter,
  typeFilter,
  onCoachFilterChange,
  onPlayerFilterChange,
  onTypeFilterChange,
  coaches,
  players,
  showFilters,
  onToggleFilters,
}: AttendanceFiltersProps) {
  return (
    <Card>
      <CardContent className="p-4 space-y-3">
        <div className="flex items-center gap-3 flex-wrap">
          <div className="flex items-center gap-2">
            <label className="text-sm font-medium text-foreground">From</label>
            <input
              type="date"
              value={fromDate}
              onChange={(e) => onFromDateChange(e.target.value)}
              className="rounded-md border border-input bg-background text-foreground px-3 py-1.5 text-sm"
            />
          </div>
          <div className="flex items-center gap-2">
            <label className="text-sm font-medium text-foreground">To</label>
            <input
              type="date"
              value={toDate}
              onChange={(e) => onToDateChange(e.target.value)}
              className="rounded-md border border-input bg-background text-foreground px-3 py-1.5 text-sm"
            />
          </div>
          <Button
            variant="ghost"
            size="sm"
            onClick={onToggleFilters}
            className="ml-auto"
          >
            <Filter className="w-4 h-4 mr-1" />
            {showFilters ? 'Hide Filters' : 'More Filters'}
          </Button>
        </div>
        {showFilters && (
          <div className="flex items-center gap-3 flex-wrap pt-2 border-t">
            <div className="flex items-center gap-2">
              <label className="text-sm font-medium text-foreground">Coach</label>
              <select
                value={coachFilter}
                onChange={(e) => onCoachFilterChange(e.target.value)}
                className="rounded-md border border-input bg-background text-foreground px-3 py-1.5 text-sm"
              >
                <option value="">All Coaches</option>
                {coaches?.map(c => (
                  <option key={c.id} value={c.id}>{c.name}</option>
                ))}
              </select>
            </div>
            <div className="flex items-center gap-2">
              <label className="text-sm font-medium text-foreground">Player</label>
              <select
                value={playerFilter}
                onChange={(e) => onPlayerFilterChange(e.target.value)}
                className="rounded-md border border-input bg-background text-foreground px-3 py-1.5 text-sm"
              >
                <option value="">All Players</option>
                {players?.map(p => (
                  <option key={p.id} value={p.id}>{p.name}</option>
                ))}
              </select>
            </div>
            <div className="flex items-center gap-2">
              <label className="text-sm font-medium text-foreground">Type</label>
              <select
                value={typeFilter}
                onChange={(e) => onTypeFilterChange(e.target.value)}
                className="rounded-md border border-input bg-background text-foreground px-3 py-1.5 text-sm"
              >
                <option value="">All Types</option>
                <option value="group">Group</option>
                <option value="private">Private</option>
              </select>
            </div>
            {(coachFilter || playerFilter || typeFilter) && (
              <Button
                variant="ghost"
                size="sm"
                onClick={() => {
                  onCoachFilterChange('');
                  onPlayerFilterChange('');
                  onTypeFilterChange('');
                }}
              >
                Clear Filters
              </Button>
            )}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
